document.addEventListener("DOMContentLoaded", () => {

    const FORMULARIO = document.getElementById("custom-mueble-form");
    const VARIANTE_PERSONALIZADO = "54065943249195";

    function actualizar() {

        const seleccionada = document.querySelector(
            'input[data-current-checked="true"]'
        );

        if (!seleccionada) {
            console.log("❌ No encontré variante");
            return;
        }

        console.log("Variant:", seleccionada.dataset.variantId);

        if (seleccionada.dataset.variantId === VARIANTE_PERSONALIZADO) {

            console.log("✅ PERSONALIZADO");

            FORMULARIO.style.display = "block";

            document.querySelectorAll("#rsi_buy_now_button").forEach(btn=>{
                btn.style.display="none";
            });

        } else {

            console.log("✅ NORMAL");

            FORMULARIO.style.display = "none";

            document.querySelectorAll("#rsi_buy_now_button").forEach(btn=>{
                btn.style.display="";
            });

        }

    }

    document.addEventListener("change", actualizar);

    actualizar();

});
/* ==========================================
   CONTADOR DE FIGURAS
========================================== */

const inputCantidad = document.getElementById("cantidadFiguras");
const btnMas = document.querySelector(".cm-plus");
const btnMenos = document.querySelector(".cm-minus");

const resumenCantidad = document.getElementById("resumenCantidad");
const precioFinal = document.getElementById("precioFinal");

const propertyCantidad = document.getElementById("propertyCantidad");
const propertyPrecio = document.getElementById("propertyPrecio");

const PRECIO_POR_FIGURA = 25000;
const PRECIO_GRABADO = 20000;
const superior = document.getElementById("grabadoSuperior");
const inferior = document.getElementById("grabadoInferior");

const resumenGrabado = document.getElementById("resumenGrabado");

const propertySuperior = document.getElementById("propertyGrabadoSuperior");
const propertyInferior = document.getElementById("propertyGrabadoInferior");

function actualizarCantidad() {

    const cantidad = parseInt(inputCantidad.value);

    // Actualizar resumen
    resumenCantidad.textContent = `${cantidad} figuras`;

   // ¿Tiene grabado?
const tieneGrabado =
    superior.value.trim() !== "" ||
    inferior.value.trim() !== "";

// Calcular precio
let total = cantidad * PRECIO_POR_FIGURA;

if (tieneGrabado) {
    total += PRECIO_GRABADO;
}

// Actualizar resumen del grabado
resumenGrabado.textContent = tieneGrabado ? "Sí" : "No";

    precioFinal.textContent =
        "$" + total.toLocaleString("es-CO");

    // Campos para Shopify
    propertyCantidad.value = cantidad + " figuras";
    propertyPrecio.value = "$" + total.toLocaleString("es-CO");
    propertySuperior.value = superior.value;
propertyInferior.value = inferior.value;
}

btnMas.addEventListener("click", () => {

    let cantidad = parseInt(inputCantidad.value);

    if (cantidad < 23) {

        cantidad++;

        inputCantidad.value = cantidad;

        actualizarCantidad();

    }

});

btnMenos.addEventListener("click", () => {

    let cantidad = parseInt(inputCantidad.value);

    if (cantidad > 3) {

        cantidad--;

        inputCantidad.value = cantidad;

        actualizarCantidad();

    }

});

// Inicializar
actualizarCantidad();
/* ==========================================
   ACTUALIZAR COLOR
========================================== */

const radiosColor = document.querySelectorAll('input[name="color"]');

const resumenColor = document.getElementById("resumenColor");
const propertyColor = document.getElementById("propertyColor");

function actualizarColor() {

    const seleccionado = document.querySelector('input[name="color"]:checked');

    if (!seleccionado) return;

    resumenColor.textContent = seleccionado.value;
    propertyColor.value = seleccionado.value;

}

radiosColor.forEach(radio => {

    radio.addEventListener("change", actualizarColor);

});

actualizarColor();
superior.addEventListener("input", actualizarCantidad);
inferior.addEventListener("input", actualizarCantidad);
/* ==========================================
   BOTÓN WHATSAPP
========================================== */

const btnSolicitar = document.getElementById("btnSolicitarMueble");

btnSolicitar.addEventListener("click", () => {

    const cantidad = inputCantidad.value;
    const color = document.querySelector('input[name="color"]:checked').value;
    const precio = precioFinal.textContent;

    const textoSuperior = superior.value.trim();
    const textoInferior = inferior.value.trim();

    let mensaje = `¡Hola! 👋

Quiero solicitar un mueble personalizado.

📦 Cantidad de figuras: ${cantidad}
🎨 Color: ${color}`;

    if (textoSuperior || textoInferior) {

        mensaje += `

✍ Grabado:
• Superior: ${textoSuperior || "Sin texto"}
• Inferior: ${textoInferior || "Sin texto"}`;

    } else {

        mensaje += `

✍ Grabado: No`;

    }

    mensaje += `

💰 Precio: ${precio}

Quedo atento para continuar con mi pedido.`;

    // CAMBIA ESTE NÚMERO POR EL TUYO
    const telefono = "573001234567";

    window.open(
        `https://wa.me/${telefono}?text=${encodeURIComponent(mensaje)}`,
        "_blank"
    );

});